import { render } from "./AppHeader.vue?vue&type=template&id=cac218c2"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lykaon/gitlykaon/people-measurement-system.webapp.staging/cloud/pms_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__